// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"SpinnerWrapper_spinnerContainer__93tKw"};